
export interface Tax {
  id: string;
  rate: number;
  name: string;
}
